export default {
  'nav.home': 'Inicio',
  'nav.shoppingGuide': 'Guía de compras',
  'nav.categories': 'Categorías',
  'nav.faq': 'FAQ',
  'nav.mainSite': 'Visitar sitio principal',
  'nav.language': 'Idioma',

  'hero.eyebrow': 'Recurso independiente · Actualizado 2026',
  'hero.title': 'Guía Basetao Spreadsheet',
  'hero.subtitle':
    'Encuentra, compara y organiza productos con recursos prácticos de Basetao Spreadsheet, guías de investigación de productos, hallazgos, información de envío y reseñas — todo en un lugar independiente.',
  'hero.ctaPrimary': 'basetao spreadsheet',
  'hero.ctaSecondary': 'comprar ahora',
  'hero.ctaGuide': 'Explora la guía completa',

  'categories.title': 'Explorar por categoría',
  'categories.subtitle':
    'Elige una categoría a continuación para ir directamente a las listas de productos curadas en el sitio principal.',
  'categories.dropdownLabel': 'Seleccionar una categoría',

  'guide.title': '¿Qué es un Basetao Spreadsheet?',
  'guide.lead':
    'Un Basetao Spreadsheet es una forma sencilla de organizar los productos que encuentras, comparar precios y vendedores, y mantener cada enlace y detalle de envío en un solo lugar limpio.',

  'article.title': 'Explora las guías Basetao',
  'article.subtitle': 'Diez guías pilar en profundidad para ayudarte a investigar, enviar y ahorrar de forma más inteligente.',
  'article.readMore': 'Leer artículo',

  'faq.title': 'Preguntas frecuentes',
  'faq.subtitle': 'Respuestas rápidas sobre Basetao Spreadsheet y este sitio.',

  'cta.title': '¿Listo para seguir investigando?',
  'cta.subtitle':
    'Continúa tu investigación de productos con nuestras guías, o dirígete al sitio principal para empezar a crear tus propios hallazgos.',
  'cta.mainSite': 'Visitar sitio principal',
  'cta.guide': 'Continuar tu investigación',

  'footer.tagline':
    'Un recurso de información independiente sobre Basetao Spreadsheet. No afiliado ni respaldado por Basetao.',
  'footer.resources': 'Recursos',
  'footer.company': 'Empresa',
  'footer.languages': 'Idiomas',
  'footer.disclaimer':
    'Basetao Sheet Guide es un sitio de información independiente y no está afiliado ni respaldado por Basetao, a menos que se indique explícitamente.',

  'hero.demoLabel': 'Datos de demostración solo para fines ilustrativos.',
  'guide.readFullGuide': 'Leer la guía completa',
  'guide.exampleLabel': 'Estructura de hoja de cálculo de ejemplo (datos de demostración)',

  'article.faqTitle': 'Preguntas frecuentes',
  'article.relatedTitle': 'Guías relacionadas',
  'article.ctaTitle': 'Continuar tu investigación',
  'article.ctaText':
    '¿Listo para empezar a añadir productos a tu hoja? Explora las categorías o vuelve a la página de inicio para más recursos.',
  'article.backToHome': 'Volver al inicio',
  'article.visitMainSite': 'Visitar sitio principal',
  'article.author': 'Equipo de Basetao Sheet Guide',

  'notFound.title': 'Artículo no encontrado',
  'notFound.text':
    'La página que buscas no existe. Vuelve a la página de inicio para explorar nuestras guías.',
  'notFound.backToHome': 'Volver al inicio',

  'home.metaDescription':
    'Explora guías de Basetao Spreadsheet, hallazgos, reseñas, costos de envío, información de almacén, consejos de control de calidad, cupones y recursos prácticos.',
};